var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('b-card',[_c('user-edit-form',{attrs:{"user-resource":_vm.userResource,"submit-text":"Save Profile","success-message":"Profile Saved!"}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"mb-1"},[_vm._v("Profile")]),_c('p',{staticClass:"text-muted mb-0"},[_vm._v("Manage your personal information and racer details.")])])
}]

export { render, staticRenderFns }